import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import GalleryPage from './pages/GalleryPages';
import EventPage from './pages/EventPages';
import AboutPage from './pages/AboutPage';

const App = () => {
  return (
    <Router>
      <div className="bg-white min-h-screen">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/about" element={<AboutPage/>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;